const nonProDomainWildcard = [
  // @foo.*
  '@126.',
  '@163.',
  '@4money.',
  '@adbert.',
  '@aol.',
  '@cong9184.',
  '@daum.',
  'email.',
  '@foxmail.',
  '@gmx.',
  '@google.',
  '@hotmail.',
  '@icloud.',
  '@intrees.',
  '@live.',
  '@mailinator.',
  '@me.',
  '@msn.',
  '@naver.',
  '@outlook.',
  '@pm.',
  '@protonmail.',
  '@qq.',
  '@rambler.',
  '@rediffmail.',
  '@reutd.',
  '@sharklasers.',
  '@sina.',
  '@sohu.',
  '@stesting.',
  '@testing.',
  '@test.',
  '@ttirv.',
  '@vip.qq.',
  '@webrand.',
  '@wp.',
  '@yahoo.',
  '@yandex.',
  '@ymail.',
  '@yopmail.',
];

const nonProDomainSpecific = [
  // @foo.bar
  '@alo.com',
  '@aol.com',
  '@armyspy.com',
  '@business.com',
  '@email.com',
  '@gufum.com',
  '@hot.com',
  '@htoal.com',
  '@info.com',
  '@mail.com',
  '@mail.ru',
  '@mailinator.com',
  '@navercorp.com',
  '@rhyta.com',
  '@teleworm.us',
  '@wanke.com',
  '@work.com',
  '@yoo.com',
];

const gmailVariants = ['gmail', '@gmai.com', '@gamil.com', '@gemail.com'];

export default [...nonProDomainWildcard, ...nonProDomainSpecific, ...gmailVariants];
